import { combineReducers } from "redux";

import purpose from "../features/admin/master/purpose/Slice";
import category from "../features/admin/master/category/Slice";
import property_type from "../features/admin/master/property_type/Slice";
import furnish_type from "../features/admin/master/furnish_type/Slice";
import bhk from "../features/admin/master/bhk/Slice";
import facing from "../features/admin/master/facing/Slice";
import availability from "../features/admin/master/availability/Slice";
import key_heighlight from "../features/admin/master/key_heighlight/Slice";
import possession from "../features/admin/master/possession/Slice";
import amenities from "../features/admin/master/amenities/Slice";
import workstart from "../features/admin/master/work_start/Slice";
import appsetup from "../features/admin/master/appsetup/Slice";
import dashboard from "../features/admin/dashboard/dashboard/slice";
import areains from "../features/admin/master/areain/Slice";
import parkings from "../features/admin/master/parking/Slice.js";

const Masters = combineReducers({
  purpose,
  category,
  property_type,
  furnish_type,
  bhk,
  facing,
  availability,
  key_heighlight,
  possession,
  amenities,
  workstart,
  appsetup,
  dashboard,
  areains,
  parkings,
});

export default Masters;
